export const userConstants = {
    LOGIN: 'LOGIN',
    CSRF: 'CSRF',
    UPDATE_POINT: 'UPDATE_POINT',
    UPDATE_TOKEN: 'UPDATE_TOKEN',
    UPDATE_STAMP: 'UPDATE_STAMP',
}
